import { DeleteOutlined, UserAddOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Select, Table, Typography } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import {
  listUserPost,
  userPostAdd,
  userPostDelete
} from '../../services/postservice'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'
import { requestManagerAdd } from '../../services/requestservice'
import { removeVietnameseTones } from '../../config-func'
const { Option } = Select
const { Text } = Typography

const Manage = ({
  getList,
  setOpen,
  requestId,
  data = [],
  setSelectedRowKeys
}) => {
  const [managers, setManagers] = useState([
    // { id: 2116, name: 'Lê Văn Dương', phone: '0971516193' }
  ])
  const [loading, setLoading] = useState(false)
  const [selectedManager, setSelectedManager] = useState(null)

  const handleDelete = async (id) => {
    const body = {
      post_id: requestId,
      assigner_id: id,
      from: 2
    }

    try {
      const res = await userPostDelete(body)
      openNotification('success', 'Xóa thành công quản lý tin')
      getListUserRequest()
    } catch (err) {
      openNotification('error', 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const getListUserRequest = async () => {
    // setLoading(true)
    // try {
    //   const res = await listUserPost(requestId)
    //   if (res?.data) {
    //     setManagers(res?.data?.list)
    //   }
    // } catch (err) {
    //   openNotification('error', 'Đã có lỗi xảy ra')
    // } finally {
    //   setLoading(false)
    // }
  }
  const handleAdd = async () => {
    setLoading(true)
    try {
      const body = {
        manager_post_id: selectedManager,
        posts_id: requestId
      }
      const res = await userPostAdd(body)
      if (res?.data?.list) {
        setOpen(false)
        setSelectedRowKeys([])
        openNotification('success', 'Thêm thành công quản lý vào tin đăng')
        getList()
      } else {
        openNotification('error', 'Có lỗi xảy ra')
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setSelectedManager(null) // Reset giá trị Select sau khi gọi API
    }
  }

  return (
    <div className={styles.listManagePost}>
      {/* <Table
        loading={loading}
        dataSource={managers}
        pagination={false}
        rowKey="id"
        scroll={{ y: 300 }}
        bordered
        columns={[
          {
            title: 'Tên quản lý',
            dataIndex: 'name',
            key: 'name',
            width: '60%',
            render: (text, record) => `${record?.manager_post_info?.name}`
          },
          {
            title: 'SĐT',
            dataIndex: 'phone',
            key: 'phone',
            width: '30%',
            render: (text, record) => `${record?.manager_post_info?.phone}`
          },
          {
            key: 'action',
            render: (text, record) => (
              //   <Button
              //     type="text"
              //     danger
              //     icon={<DeleteOutlined />}
              //     onClick={() => handleDelete(record.manager_post_id)}
              //   />
              <Popconfirm
                title="Xóa quản lý tin?"
                onConfirm={() => handleDelete(record.manager_post_id)}
              >
                <DeleteOutlined key="delete" style={{ color: 'red' }} />
              </Popconfirm>
            ),
            align: 'center'
          }
        ]}
      /> */}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 20
        }}
      >
        <div>Thêm quản lý:</div>
        <Select
          style={{ width: '70%' }}
          placeholder="Chọn quản lý"
          value={selectedManager} // Gán value từ state
          onChange={(value) => setSelectedManager(value)}
          allowClear
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase();
            const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
            return optionValue.includes(inputValue);
          }}
        >
          {data.map((item) => {
            const isDisabled = managers.some(
              (manager) => manager.manager_post_id === item.id
            )

            return (
              <Option key={item.id} value={item.id} disabled={isDisabled}>
                {item.name}
              </Option>
            )
          })}
        </Select>

        <Button type="primary" icon={<UserAddOutlined />} onClick={handleAdd} />
      </div>
    </div>
  )
}

export default Manage
